<template>
  <div class="tldetailcont">
    <div class="bt">
      {{ tlinfo.title }}
    </div>
    <div class="abstract">
      <div class="abs center">
        <div class="abs1">
          <div>颁布单位：{{ tlinfo.issue_unit }}</div>
          <div>法院文号： {{ tlinfo.issue_number }}</div>
          <div>颁布日期：{{ tlinfo.issue_date }}</div>
        </div>
        <div class="abs2">
          <div>执行日期：{{ tlinfo.effect_date }}</div>
          <div>
            时 效 性：
            <span v-if="tlinfo.timeliness == 1">现行有效</span>
            <span v-if="tlinfo.timeliness == 2">现已失效</span>
            <span v-if="tlinfo.timeliness == 3">尚未生效</span>
            <span v-if="tlinfo.timeliness == 4">已修订</span>
          </div>
          <div>效力级别：{{ tlinfo.effect_level }}</div>
        </div>
      </div>
    </div>
    <div class="cont" v-html="tlinfo.content"></div>
  </div>
</template>

<script>
export default {
  data: () => ({
    tlId: 0,
    tlinfo: {},
  }),
  beforeMount() {
    this.tlId = this.$route.query.tlId || 1;
    this.gettlinfo();
  },
  methods: {
    gettlinfo() {
      let data = {
        id: this.tlId,
      };
      this.$http.jpcol.gettiaolicontent(data).then((res) => {
        this.tlinfo = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tldetailcont {
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  .bt {
    padding: 44px 0;
    text-align: center;
    width: 670px;
    font-size: 28px;
    margin: 0 auto;
    color: #333333;
  }
  .abstract {
    width: 100%;
    font-size: 12px;
    color: #666666;
    height: 96px;
    background: #fcfcfc;
    .abs {
      height: 100%;
      margin: 0 auto;
      line-height: 24px;
      .abs1 {
        margin-right: 30px;
      }
    }
  }
  .cont {
    padding: 35px;
    color: #666666;
    line-height: 50px;
  }
}
</style>